import React, { useState, Suspense, useEffect } from "react";
import { matchRoutes, renderRoutes } from "react-router-config";
import { ProgressBar } from "react-bootstrap";
import PropTypes from "prop-types";

import { NavBar, TopBar } from "components";
import { isAuthenticated } from "store/auth";
import { useLocation } from "react-router";
import useRouter from "util/useRouter";

import "../styles.css";

const root = {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const container = {
  background: "#F8F8F9",
  display: "flex",
  flex: "1 1 auto",
  overflow: "hidden",
};

const content = {
  overflowY: "auto",
  flex: "1 1 auto",
};

const topBar = {
  zIndex: 2,
  position: "relative",
};

const navBar = {
  //Dominos
  background: "#006491",

  //Outros
  // background: "#FFFFFF",
  zIndex: 3,
  width: 256,
  minWidth: 256,
  flex: "0 0 auto",
};

const Private = (props) => {
  const { route } = props;
  const location = useLocation();
  const { history } = useRouter();
  const [viewMenu, setViewMenu] = useState(true);

  useEffect(() => {
    const branch = matchRoutes(route.routes, location.pathname);

    if (sessionStorage.getItem("@authenticator/permission") !== null) {
      const permissions = JSON.parse(
        sessionStorage.getItem("@authenticator/permission")
      );
      if (
        permissions.routes_front_allowed &&
        permissions.routes_front_allowed.AUTH
      ) {
        const path = permissions.routes_front_allowed.AUTH.filter(
          (route) => route === branch[0].match.path
        );

        if (path.length === 0) history.push("/acesso_negado");
      } else {
        history.push("/acesso_negado");
      }
    }
  }, [history, location, route.routes]);

  // Validação de login
  if (!isAuthenticated()) {
    history.push("/auth/login");
    return null;
  }

  const toggleMenu = () => {
    setViewMenu(!viewMenu);
  };

  return (
    <div style={root}>
      <div style={container}>
        {viewMenu && (
          <div style={navBar}>
            <NavBar />
          </div>
        )}

        <main style={content}>
          <div style={topBar}>
            <TopBar toggleMenu={toggleMenu} />
          </div>
          <Suspense fallback={<ProgressBar striped />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </main>
      </div>
    </div>
  );
};

Private.propTypes = {
  route: PropTypes.object,
};

export default Private;
